import React, { createContext, useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import { baseURLProd } from "../api";
// import { baseURLProd } from "../api";

export const AttendanceContext = createContext();

export const AttendanceProvider = ({ children }) => {
  const [classDetails, setClassDetails] = useState([]);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    fetchPreviousAttendance();
  }, []);

  const fetchPreviousAttendance = async () => {
    const userId = localStorage.getItem("userId");

    try {
      const response = await fetch(`${baseURLProd}previous-attendance`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ user_id: userId }),
      });

      const data = await response.json();

      if (data.class_detail?.length) {
        setClassDetails(data.class_detail);
        setShowPopup(true);
        localStorage.setItem("stopAttendanceCheck", "true"); // Stop further API calls
      } else {
        // If no class details, continue calling the API
        setTimeout(fetchPreviousAttendance, 2000); // Retry after 5 seconds
      }
    } catch (error) {
      console.error("Error fetching previous attendance:", error);
    }
  };



  //   const markAttendance = async (scheduleId, center, type, isMark) => {
  //     const userId = localStorage.getItem("userId");

  //     try {
  //       const response = await fetch(`${baseURLProd}backup-attendance`, {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({
  //           schedule_id: scheduleId,
  //           center,
  //           type,
  //           user_id: userId,
  //           is_mark: isMark,
  //         }),
  //       });

  //       const data = await response.json();

  //       if (data.status === true) {
  //         toast.success("Attendance Marked Successfully!");
  //         fetchPreviousAttendance();
  //       } else {
  //         alert("Failed to mark attendance: " + data.message);
  //       }
  //     } catch (error) {
  //       console.error("Error marking attendance:", error);
  //     }
  //   };
  const markAttendance = async (scheduleId, center, type, isMark) => {
    const userId = localStorage.getItem("userId");

    try {
      const response = await fetch(`${baseURLProd}backup-attendance`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          schedule_id: scheduleId,
          center,
          type,
          user_id: userId,
          is_mark: isMark,
        }),
      });

      const data = await response.json();

      if (data.status === true) {
        toast.success('Attendance Marked Successfully!');
        setClassDetails((prevDetails) =>
          prevDetails.filter((item) => item.schedule_id !== scheduleId)
        );

        if (classDetails.length === 1) {
          toast.success("All attendance marked Successfully");
          window.location.reload();
        }
      } else {
        alert("Failed to mark attendance: " + data.message);
      }
    } catch (error) {
      console.error("Error marking attendance:", error);
    }
  };


  return (
    <AttendanceContext.Provider value={{ fetchPreviousAttendance }}>
      {children}
      <ToastContainer />
      {showPopup && (
        <div>
          <div
            className="modal-backdrop"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 1040,
            }}
          ></div>
          <div className="modal fade show" style={{ display: "block" }} tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header d-flex justify-content-end">
                  <h5 className="modal-title"></h5>
                </div>
                <div className="modal-body ">
                  <h6 className="fw text-center">Are you sure you want to mark your attendance?</h6>
                  {classDetails.map((item) => (
                    <div key={item.schedule_id} className="class-item my-4">
                      <div className="d-flex justify-content-between">
                        <b>Date:</b> <p>{item.date}</p>
                      </div>
                      <div className="d-flex justify-content-between">
                        <b>Time:</b> <p>{item.time}</p>
                      </div>
                      <div className="d-flex justify-content-between">
                        <b>Topics:</b> <p>{item.topic}</p>
                      </div>
                      <div className="d-flex justify-content-around">
                        <button className="absentBtn" onClick={() => markAttendance(item.schedule_id, item.center, item.type, 0)}>
                          Absent
                        </button>
                        <button className="presentBtn" onClick={() => markAttendance(item.schedule_id, item.center, item.type, 1)}>
                          Present
                        </button>
                      </div>
                      <hr />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </AttendanceContext.Provider>
  );
};
